import { styled as n } from "./styled2.mjs";
import { Typography as t } from "./index59.mjs";
import { EDropzoneFileStatus as i } from "./types.mjs";
const s = n("li")`
	display: flex;
	flex-grow: 1;
	align-items: center;
`, c = n("div")`
	display: flex;
	flex-grow: 1;
	background-color: ${({ theme: e }) => e.palette.background.level3};
	border: ${({ theme: e, $fileStyle: o }) => o === "outlined" ? `1px solid ${e.palette.other.divider}` : "none"};
	border-radius: ${({ theme: e }) => e.spacing(1)};
	padding: ${({ theme: e, $status: o }) => ` ${o === i.Uploading ? e.spacing(2) : e.spacing(1)} ${e.spacing(1.5)}`};
	align-items: center;
`, p = n("div")`
	display: flex;
	flex-grow: 1;
	position: relative;
`, d = n("div")`
	display: flex;
	align-items: center;
	gap: ${({ theme: e }) => e.spacing(1)};
	margin-left: auto;
`, g = n("div")`
	display: flex;
	flex-direction: column;
	justify-content: center;
	gap: 2px;
`, f = n("div")`
	display: flex;
	align-items: center;
	justify-content: center;
	margin-right: ${({ theme: e }) => e.spacing(1.5)};
`, u = n("div")`
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	padding: ${({ theme: e }) => e.spacing(1)};
	font-size: 16px;
	${({ theme: e, $status: o }) => {
  switch (o) {
    case i.Done:
      return `background-color : ${e.palette.success.main08}`;
    case i.Uploading:
      return `background-color : ${e.palette.primary.main08}`;
    default:
      return `background-color : ${e.palette.error.main08}`;
  }
}};
`;
n(t.Caption)`
	color: ${({ theme: e }) => e.palette.error.main};
`;
const m = n(t.Body1)`
	cursor: ${({ $isDisabled: e }) => e ? "default" : "pointer"};
	pointer-events: ${({ $isDisabled: e }) => e ? "none" : "unset"};

	overflow-wrap: anywhere;
`;
export {
  c as FileComponent,
  p as FileContent,
  d as FileControls,
  g as FileInfo,
  s as FileListItem,
  m as FileName,
  u as UploadIconCirle,
  f as UploadIconSlot
};
//# sourceMappingURL=styles40.mjs.map
